import { styled } from "../../stitches.config";
import { ScrollStyles } from "../common/common.style";
import { Box, FlexBox, Image } from "../primitives";

export const CardImage = styled(Image, {
  width: "170px",
  height: "230px",
  borderRadius: "4px",
  objectFit: "cover",
  marginTop: 5,
});

export const CardWrapper = styled(FlexBox, {
  width: 310,
  border: "1px solid #ddd",
  borderRadius: "6px",
  padding: "0.75rem",
  marginBottom: "0.5rem",
  gap: "1rem",
  alignSelf: "flex-start",
  height: "310px",
  position: "relative",
});

export const ActionWrapper = styled(FlexBox, {
  margin: "auto 0 0 auto",
  gap: 10,
  alignItems: "center",
});

export const CardName = styled(Box, {
  fontSize: 14,
  display: "inline-block",
  width: 260,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontWeight: "bold",
});

export const SubTitle = styled(Box, {
  color: "#555",
  fontSize: 12,
  display: "inline-block",
  width: 240,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const InformationWrapper = styled(FlexBox, {
  flexDirection: "column",
  gap: 10,
  alignItems: "center",
  width: 110,
  maxHeight: 230,
  overflow: "auto",
  ...ScrollStyles,
});

export const DescriptionWrapper = styled(Box, {
  fontSize: 12,
  height: 20,
  display: "flex",
  alignItems: "center",
  paddingTop: 10,
  flexShrink: 1,
});

export const DescriptionSpan = styled("span", {
  fontSize: 12,
  display: "inline-block",
  width: 260,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const PriceOld = styled(Box, {
  fontWeight: "bold",
  color: "red",
  textDecoration: "line-through",
});

export const PriceNew = styled(Box, {
  fontWeight: "bold",
  color: "#166534",
  variants: {
    canBeClicked: { true: { cursor: "pointer" }, false: { cursor: "default" } },
  },
});

export const PropertyWrapper = styled(FlexBox, {
  gap: 5,
  alignItems: "center",
});

export const ConditionWrapper = styled(Box, {
  color: "white",
  padding: "2px 5px",
  borderRadius: 4,
});
